import axios from "../axios";
import { recommendedGiftURL } from "../requests";
export const getRecommendedGiftApi = (token: string) => {
  return axios.get(recommendedGiftURL, {
    headers: { token },
  });
};
